import { IsArrivingComponent } from './components/is-arriving/is-arriving.component';
import { AgmDirectionModule } from 'agm-direction';
import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import * as _ from 'lodash';

import { AgmCoreModule } from '@agm/core';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ModalModule } from 'ngx-bootstrap/modal';

import '../../../node_modules/slick-carousel/slick/slick.less';
import '../../../node_modules/ng-toast/dist/ngToast.css';
import '../../../node_modules/slick-carousel/slick/slick.js';

import { AlertModule } from 'ngx-bootstrap/alert';
import { TimetableService } from '../shared/services/timetable-service';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { GxDatePipe } from './pipes/gx-date.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { ErrorSummaryComponent } from './components/error-summary/error-summary.component';
import { HeadlessCmsService } from './services/headless-cms.service';
import { GenericContentPageResolve } from './resolver/generic.resolve';
import { BookingService } from './services/booking.service';
import { ActionUpdaterService } from './services/action-updater.service';
import { StepsIndicatorComponent } from './components/steps-indicator/steps-indicator.component';
import { PickStopComponent } from './components/pick-stop/pick-stop.component';
import { IsReturnComponent } from './components/is-return/is-return.component';
import { PickadateDirective } from './components/pick-a-date/pickadate.directive';
import { PickADateComponent } from './components/pick-a-date/pick-a-date.component';
import { CounterComponent } from './components/counter/counter.component';
import { LocalStorageService } from './services/local-storage.service';
import { SlickSliderComponent } from './components/slick-slider/slick-slider.component';
import { RunningDogModalComponent } from './components/running-dog-modal/running-dog-modal.component';
import { PaymentService } from './services/payment.service';
import { ConfirmationBookingDetailComponent } from './components/confirmation-booking-detail/confirmation-booking-detail.component';
import { ReferenceDataService } from './services/reference-data.service';
import { ToastComponent } from './components/toast/toast.component';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { BusyMessageDirective } from './components/busymessage/busymessage.directive';
import { DeviceService } from './services/device.service';
import { FeatureService } from './services/feature.service';
import { UmbracoService } from './services/umbraco.service';
import { GoogleMapComponent } from './components/google-map/google-map.component';
import { CreditCardService } from './services/credit-card.service';
import { AutocompleteOffService } from 'app/shared/services/autocomplete-off.service';
import { WindowRefManager } from 'app/shared/services/window.service';
import { KmPassService } from 'app/shared/services/km-pass.service';
import { PassengerOptionsStateService } from 'app/shared/services/passenger-options-state.service';
import { PassengersService } from 'app/shared/services/passenger.service';
import { FaresService } from 'app/shared/services/fares.service';
import { GxUtilsService } from 'app/shared/services/gx-utils.service';
import { TravelService } from 'app/shared/services/travel.service';
import { SelectListComponent } from 'app/shared/components/select-list/select-list.component';
import { SeatAllocationsComponent } from 'app/shared/components/seat-allocations/seat-allocations.component';
import { InfoComponent } from 'app/shared/components/info/info.component';
import { TripDetailsComponent } from 'app/shared/components/trip-details/trip-details.component';
import { DatetimeComponent } from 'app/shared/components/datetime/datetime.component';
import { AlertDialogComponent } from './dialogs/alert-dialog/alert-dialog.component'
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component'
import { SelectOptionSetComponent } from './dialogs/select-option-set-dialog/select-option-set-dialog.component'
import { PrettyPassengerPipe } from 'app/shared/pipes/pretty-passenger.pipe';
import { CartTotalService } from 'app/shared/services/cart-total.service';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { AddonsService } from 'app/shared/services/addons.service';
import { SectorAddonsService } from 'app/shared/services/sector-addons.service';
import { ErrorService } from 'app/shared/services/error.service';
import { EventBusService } from 'app/shared/services/event-bus.service';
import { CollapsingHeaderComponent } from 'app/shared/components/collapsing-header/collapsing-header.component';
import { TravelProductService } from 'app/shared/services/travel-product.service';
import { ItineraryComponent } from '../shared/components/itinerary/itinerary.component';
import { TravelDatesComponent } from '../shared/components/itinerary/travel-dates/travel-dates.component';
import { InclusionsComponent } from '../shared/components/itinerary/inclusions/inclusions.component';
import {
    AvailabilityWrapperComponent
} from '../shared/components/itinerary/travel-dates/availability-wrapper/availability-wrapper.component';
import {
    AvailabilityTableComponent
} from '../shared/components/itinerary/travel-dates/availability-table/availability-table.component';
import { SectorComponent } from '../shared/components/itinerary/travel-dates/sector/sector.component';
import { SectorAddonsComponent } from './components/itinerary/travel-dates/sector/sector-addons-wrapper/sector-addons/sector-addons.component';
import { SectorAddonsWrapperComponent } from './components/itinerary/travel-dates/sector/sector-addons-wrapper/sector-addons-wrapper.component';
import { PurchaseTotalWrapperComponent } from './components/purchase-total-wrapper/purchase-total-wrapper.component';
import { OpenAddonsComponent } from './components/itinerary/travel-dates/open-addons-wrapper/open-addons/open-addons.component';
import { OpenAddonsWrapperComponent } from './components/itinerary/travel-dates/open-addons-wrapper/open-addons-wrapper.component';
import {
    ChangeSectorDateComponent
} from '../shared/components/itinerary/travel-dates/change-sector-date/change-sector-date.component';
import { PickATimeComponent } from './components/pick-time/pick-a-time.component';
import { PickatimeDirective } from './components/pick-time/pickatime.directive';
import { HomePassengerOptionsComponent } from '../shared/components/home-passenger-options/home-passenger-options.component';
import { ScrollToOnDirective } from 'app/shared/components/scroll-to-on/scroll-to-on.directive';
import { ExpressBookingService } from './services/express-booking-widget';
import { SpecialAssistanceComponent } from './components/special-assistance/special-assistance.component';
import { PageTransitionComponent } from './components/page-transition/page-transition.component';
import { ProductSummaryComponent } from 'app/travel-products/product-passenger-details/product-summary/product-summary.component';
import { SummaryComponent } from 'app/travel-products/product-passenger-details/summary/summary.component';
import { BookingTotalComponent } from 'app/travel-products/product-passenger-details/booking-total/booking-total.component';
import { ProductPaymentComponent } from 'app/travel-products/product-payment/product-payment.component';
import { SeatConfirmationComponent } from 'app/travel-products/seat-confirmation/seat-confirmation.component';
import { PaymentFormComponent } from 'app/travel-products/product-payment/payment-form/payment-form.component';
import { UpdateSubscriptionsComponent } from './components/update-subcriptions/update-subscriptions.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // <-- import required BrowserAnimationsModule
import { CollapsibleModule } from 'angular2-collapsible';
import { TravelAlternativesPanelComponent } from 'app/shared/components/itinerary/travel-dates/travel-alternatives-panel/travel-alternatives-panel.component'

@NgModule({
    imports: [
        CommonModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBy8D7LH9NyWyHLB9m4V79TobM7DV6W8Yc'
        }),
        AgmDirectionModule,
        BsDropdownModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        TypeaheadModule.forRoot(),
        NgbTypeaheadModule.forRoot(),
        ReactiveFormsModule,
        FormsModule,
        CollapsibleModule
    ],
    declarations: [
        SafeHtmlPipe,
        GxDatePipe,
        TranslatePipe,
        PrettyPassengerPipe,
        FilterPipe,
        ErrorSummaryComponent,
        StepsIndicatorComponent,
        PickStopComponent,
        IsReturnComponent,
        PickadateDirective,
        PickADateComponent,
        CounterComponent,
        SlickSliderComponent,
        ProductSummaryComponent,
        PaymentFormComponent,
        BookingTotalComponent,
        RunningDogModalComponent,
        ConfirmationBookingDetailComponent,
        ToastComponent,
        BusyMessageDirective,
        GoogleMapComponent,
        CollapsingHeaderComponent,
        ItineraryComponent,
        TravelDatesComponent,
        InclusionsComponent,
        SectorComponent,
        SectorAddonsComponent,
        SectorAddonsWrapperComponent,
        PurchaseTotalWrapperComponent,
        OpenAddonsComponent,
        OpenAddonsWrapperComponent,
        AvailabilityTableComponent,
        ChangeSectorDateComponent,
        AvailabilityWrapperComponent,
        AlertDialogComponent,
        ConfirmDialogComponent,
        SelectOptionSetComponent,
        SelectListComponent,
        SeatAllocationsComponent,
        InfoComponent,
        TripDetailsComponent,
        DatetimeComponent,
        PickATimeComponent,
        PickatimeDirective,
        HomePassengerOptionsComponent,
        ScrollToOnDirective,
        SpecialAssistanceComponent,
        PageTransitionComponent,
        ProductPaymentComponent,
        SeatConfirmationComponent,
        SummaryComponent,
        UpdateSubscriptionsComponent,
        IsArrivingComponent,
        TravelAlternativesPanelComponent
    ],
    exports: [
        SafeHtmlPipe,
        GxDatePipe,
        TranslatePipe,
        PrettyPassengerPipe,
        FilterPipe,
        CommonModule,
        ErrorSummaryComponent,
        StepsIndicatorComponent,
        PickStopComponent,
        PickATimeComponent,
        PickatimeDirective,
        IsReturnComponent,
        PickADateComponent,
        CounterComponent,
        SlickSliderComponent,
        RunningDogModalComponent,
        ConfirmationBookingDetailComponent,
        ToastComponent,
        BusyMessageDirective,
        GoogleMapComponent,
        CollapsingHeaderComponent,
        ItineraryComponent,
        TravelDatesComponent,
        InclusionsComponent,
        SectorComponent,
        SectorAddonsComponent,
        SectorAddonsWrapperComponent,
        PurchaseTotalWrapperComponent,
        OpenAddonsComponent,
        OpenAddonsWrapperComponent,
        AvailabilityTableComponent,
        ChangeSectorDateComponent,
        AvailabilityWrapperComponent,
        AlertDialogComponent,
        ConfirmDialogComponent,
        SelectOptionSetComponent,
        SelectListComponent,
        SeatAllocationsComponent,
        InfoComponent,
        TripDetailsComponent,
        DatetimeComponent,
        HomePassengerOptionsComponent,
        ScrollToOnDirective,
        SpecialAssistanceComponent,
        PageTransitionComponent,
        PaymentFormComponent,
        ProductPaymentComponent,
        SeatConfirmationComponent,
        ProductSummaryComponent,
        BookingTotalComponent,
        SummaryComponent,
        UpdateSubscriptionsComponent,
        IsArrivingComponent,
        TravelAlternativesPanelComponent
    ],
    entryComponents: [SelectOptionSetComponent]

})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                HeadlessCmsService,
                GenericContentPageResolve,
                ActionUpdaterService,
                ProductPaymentComponent,
                SeatConfirmationComponent,
                BookingService,
                DeviceService,
                FeatureService,
                UmbracoService,
                WindowRefManager,
                ActionUpdaterService,
                AutocompleteOffService,
                LocalStorageService,
                PaymentService,
                CreditCardService,
                ReferenceDataService,
                KmPassService,
                PassengerOptionsStateService,
                PassengersService,
                FaresService,
                TravelService,
                GxUtilsService,
                CartTotalService,
                AddonsService,
                SectorAddonsService,
                ErrorService,
                EventBusService,
                TravelProductService,
                ExpressBookingService,
                BookingTotalComponent,
                PaymentFormComponent,
                TimetableService,
                ProductSummaryComponent,
                SummaryComponent
            ]
        };
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts